import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';

import Card from '../../shared/components/UIElements/Card';
import Input from '../../shared/components/FormElements/Input/Input';
import Button from '../../shared/components/FormElements/Button/Button';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
//import ImageUpload from '../../shared/components/FormElements/ImageUpload/ImageUpload';
import {
  VALIDATOR_EMAIL,
  VALIDATOR_MINLENGTH,
  VALIDATOR_REQUIRE
} from '../../shared/util/validator';
import { useForm } from '../../shared/hooks/form-hook';
import { useHttpClient } from '../../shared/hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';
import './Auth.css';

const Auth = () => {
  const auth = useContext(AuthContext);
  const [isLoginMode, setIsLoginMode] = useState(true);
  const { isLoading, error, sendRequest, clearError } = useHttpClient();

  const [formState, inputHandler, setFormData] = useForm(
    {
      email: {
        value: '',
        isValid: false
      },
      password: {
        value: '',
        isValid: false
      }
    },
    false
  );

  const switchModeHandler = () => {
    if (!isLoginMode) {
      setFormData(
        {
          ...formState.inputs,
          firstName: '',
          lastName: '',
          referral: ''
          //,image:undefined
        },
        formState.inputs.email.isValid && formState.inputs.password.isValid
      );
    } else {
      setFormData(
        {
          ...formState.inputs,
          firstName: {
            value: '',
            isValid: false
          },
          lastName: {
            value: '',
            isValid: false
          },
          referral: {
            value: '',
            isValid: false
          }
          /*,
          image: {
            value: null,
            isValid: false
          }
          */
        },
        false
      );
    }
    setIsLoginMode(prevMode => !prevMode);
  };

  const authSubmitHandler = async event => {
    event.preventDefault();

    if (isLoginMode) {
        try {
            const responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL_USER+'/login', 'POST',
                JSON.stringify({
                    email: formState.inputs.email.value,
                    password: formState.inputs.password.value
                }),
                {
                    'Content-Type': 'application/json'
                }
            );
            
            auth.login(responseData.userId, responseData.token);

        } catch (err) {
        }

    } else {
        try {
            const responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL_USER+'/signup',
                'POST',
                JSON.stringify({
                    firstName: formState.inputs.firstName.value,
                    lastName: formState.inputs.lastName.value,
                    email: formState.inputs.email.value,
                    password: formState.inputs.password.value,
                    referral: formState.inputs.referral.value
                }),
                {
                    'Content-Type': 'application/json'
                }
            );

            auth.login(responseData.userId, responseData.token);

        } catch (err) {
        }
    }
  };

  // add this to the form when image is needed {!isLoginMode && <ImageUpload center id='image' onInput={inputHandler}/>}

  return (
    <React.Fragment>
    <ErrorModal error={error} onClear={clearError}/>
    <div className='loginpage-container'>
    {isLoading && <LoadingSpinner asOverlay />}
    <div className="vaceai-auth">VACE.AI</div>
    <div className='loginpage-description'>
    </div>
    <Card className="authentication">
      {isLoginMode && <h3>Login</h3>}
      {!isLoginMode && <h3>Sign Up</h3>}
      <hr />
      <form onSubmit={authSubmitHandler}>
        {!isLoginMode && (
          <Input
            element="input"
            id="firstName"
            type="text"
            label="First Name"
            validators={[VALIDATOR_REQUIRE()]}
            errorText="Please enter first name."
            onInput={inputHandler}
          />
        )}
        {!isLoginMode && (
          <Input
            element="input"
            id="lastName"
            type="text"
            label="Last Name"
            validators={[VALIDATOR_REQUIRE()]}
            errorText="Please enter last name."
            onInput={inputHandler}
          />
        )}
        <Input
          element="input"
          id="email"
          type="email"
          label="Email Address"
          validators={[VALIDATOR_EMAIL()]}
          errorText="Please enter email address."
          onInput={inputHandler}
        />
        <Input
          element="input"
          id="password"
          type="password"
          label="Password"
          validators={[VALIDATOR_MINLENGTH(8)]}
          errorText="Password needs to be 8 characters or longer."
          onInput={inputHandler}
        />
        {!isLoginMode && (
          <Input
            element="input"
            id="referral"
            type="text"
            label="Referral Code"
            validators={[VALIDATOR_REQUIRE()]}
            errorText="Please enter referral code."
            onInput={inputHandler}
          />
        )}
        <div className="authentication-button-submit">
        <div className='submit-button'>
          <Button type="submit" disabled={!formState.isValid} transparent>
            <p style={{ letterSpacing: '0.2rem', marginTop: 0, marginBottom: 0, color: 'white' }}>
              {isLoginMode ? 'LOGIN' : 'SIGN UP'}
            </p>
          </Button>
        </div>
        </div>
      </form>
      <div className="authentication-button-switch">
        <div className='switch-button'>
          <Button onClick={switchModeHandler} transparent>
            <p style={{ letterSpacing: '0.2rem', marginTop: 0, marginBottom: 0 }}>
            {isLoginMode ? 'SIGN UP' : 'LOGIN'}
            </p>
          </Button>
        </div>
      {isLoginMode && <Link to='/reset'>Forgot Password</Link>}
      </div>
    </Card>
    </div>
    </React.Fragment>
  );
};

export default Auth;